module.exports = {
  GOOGLE_MAPS_VERSION: '3.53'
};
